// ------------------
// Google Services
// ------------------

const autocomplete = new google.maps.places.AutocompleteService();
const places = new google.maps.places.PlacesService(document.createElement('div'));



// ---------------------
// Autocomplete options
// ---------------------

const options = {
    componentRestrictions: {
        country: 'jp'
    }
};



// ---------------------
// Request function
// ---------------------

const request = body => {
    const promise = new Promise(resolve => {
        body((...args) => setTimeout(() => {
            if (promise.cancelled) return Promise.race([]);
            resolve.apply(this, args);
        }))
    });
    return promise;
};



// ---------------------
// Exports
// ---------------------

export default {

    suggest (input, _options = {}) {
        return request(resolve => {
            if (!input) return resolve([]);
            autocomplete.getPlacePredictions({...options, ..._options, input}, response => {
                resolve(response || []);
            })
        });
    },

    getLocation (placeId) {
        return request(resolve => {
            if (!placeId) return resolve(null);
            places.getDetails({placeId}, response => {
                resolve(response ? response.geometry.location.toJSON() : null);
            });
        });
    },

    getCurrentLocation () {
        return request(resolve => {
            navigator.geolocation.getCurrentPosition(
                data => resolve({
                    lat: data.coords.latitude,
                    lng: data.coords.longitude
                }),
                () => resolve(),
                {
                    timeout: 30000
                }
            )
        });
    },

    cancel (request) {
        request && (request.cancelled = true);
    }

};
